// @ts-ignore
import scanSound from '../assets/audio/scan.mp3';
// @ts-ignore
import scanFailedSound from '../assets/audio/scanFailed.mp3';
// @ts-ignore
import scanFailedSoundAo from '../assets/audio/scanFailedAo.mp3';
// @ts-ignore
import repeatedScanSound from '../assets/audio/repeatedScan.mp3';

/**
 * Check if the device is iOS
 */
const isIOS = (): boolean => {
  return /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
};

// iOS 音频共享实例
let sharedScanAudio: HTMLAudioElement | null = null;
let sharedScanFailedAudio: HTMLAudioElement | null = null;
let sharedScanFailedAoAudio: HTMLAudioElement | null = null;
let sharedRepeatedScanAudio: HTMLAudioElement | null = null;

/**
 * Play scan sound
 */
export const playScanSound = async (): Promise<void> => {
  if (isIOS()) {
    try {
      if (!sharedScanAudio) {
        sharedScanAudio = new Audio(scanSound);
        sharedScanAudio.load();
      } else {
        sharedScanAudio.currentTime = 0;
      }

      // 非 await，避免阻塞 WKWebView
      void sharedScanAudio.play().catch(err => {
        console.error('iOS failed to play scan sound:', err);
      });
    } catch (err) {
      console.error('Unexpected iOS scan sound error:', err);
    }
    return;
  }

  // Android 或其他平台：保持原来的逻辑
  const successAudio = new Audio(scanSound);
  return successAudio.play().catch(err => {
    console.error('Failed to play scan sound:', err);
  });
};

/**
 * Play scan failed sound
 */
export const playScanFailedSound = async (): Promise<void> => {
  if (isIOS()) {
    try {
      if (!sharedScanFailedAudio) {
        sharedScanFailedAudio = new Audio(scanFailedSound);
        sharedScanFailedAudio.load();
      } else {
        sharedScanFailedAudio.currentTime = 0;
      }

      void sharedScanFailedAudio.play().catch(err => {
        console.error('iOS failed to play failed scan sound:', err);
      });
    } catch (err) {
      console.error('Unexpected iOS scan failed sound error:', err);
    }
    return;
  }

  const failAudio = new Audio(scanFailedSound);
  return failAudio.play().catch(err => {
    console.error('Failed to play failed sound:', err);
  });
};

/**
 * Play scan failed ao sound
 */
export const playScanFailedAoSound = async (): Promise<void> => {
  if (isIOS()) {
    try {
      if (!sharedScanFailedAoAudio) {
        sharedScanFailedAoAudio = new Audio(scanFailedSoundAo);
        sharedScanFailedAoAudio.load();
      } else {
        sharedScanFailedAoAudio.currentTime = 0;
      }

      void sharedScanFailedAoAudio.play().catch(err => {
        console.error('iOS failed to play scan failed ao sound:', err);
      });
    } catch (err) {
      console.error('Unexpected iOS scan failed ao sound error:', err);
    }
    return;
  }

  const failedAoAudio = new Audio(scanFailedSoundAo);
  return failedAoAudio.play().catch(err => {
    console.error('Failed to play scan failed ao sound:', err);
  });
};

/**
 * Play repeated scan sound
 */
export const playRepeatedScanSound = async (): Promise<void> => {
  if (isIOS()) {
    try {
      if (!sharedRepeatedScanAudio) {
        sharedRepeatedScanAudio = new Audio(repeatedScanSound);
        sharedRepeatedScanAudio.load();
      } else {
        sharedRepeatedScanAudio.currentTime = 0;
      }

      void sharedRepeatedScanAudio.play().catch(err => {
        console.error('iOS failed to play repeated scan sound:', err);
      });
    } catch (err) {
      console.error('Unexpected iOS repeated scan sound error:', err);
    }
    return;
  }

  const repeatedAudio = new Audio(repeatedScanSound);
  return repeatedAudio.play().catch(err => {
    console.error('Failed to play repeated scan sound:', err);
  });
};
